import gql from 'graphql-tag';

export default gql`
  fragment groupFragment on GroupType {
    id
    name
    mainImage
    mainImageUrl
    content
    location
    owner
    isAdmin
    groupAdminCount
    groupMemberCount
    groupFollowerCount
  }
`;
